import React from 'react';

const UserCheckIcon = () => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 13.5C0.499941 12.388 0.810894 11.2996 1.39554 10.3655C1.98019 9.43131 2.81369 8.69106 3.79602 8.23356C4.77835 7.77607 5.86777 7.62075 6.93353 7.78627C7.9993 7.95178 8.99613 8.43109 9.8044 9.16667M10.3 12.0556L11.7 13.5L14.5 10.6111M9.6 4.11111C9.6 6.10547 8.033 7.72222 6.1 7.72222C4.167 7.72222 2.6 6.10547 2.6 4.11111C2.6 2.11675 4.167 0.5 6.1 0.5C8.033 0.5 9.6 2.11675 9.6 4.11111Z"
      stroke="#007AAE"
      stroke-opacity="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default UserCheckIcon;
